var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useState } from "react";
import { DataSourceBrowserModal } from "@components/DataSourceBrowser/DataSourceBrowserModal";
import { askQuestion, getSampleQuestions } from "@query-engine-service";
import { generateInitialQuery, getSchemaForSource, prepareQuery } from "@utils";
import { ButtonComponent, TextArea } from "uxp/components";
import { QueryBuilderContext } from "@query-builder/QueryBuilderContext";
import { Loading, LoadingOverlay } from "@components/Loading/Loading";
import './InitialScreen.scss';
export const InitialScreen = props => {
    const context = useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    const [view, setView] = useState('init');
    const [origins, setOrigins] = useState([]);
    const [question, setQuestion] = useState('');
    const [processingQuestion, setProcessingQuestion] = useState(false);
    const [loadingSamples, setLoadingSamples] = useState(false);
    const [samples, setSamples] = useState([]);
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if ((_a = props === null || props === void 0 ? void 0 : props.query) === null || _a === void 0 ? void 0 : _a.sourceOnly) {
            setView('source');
            if ((_e = (_d = (_c = (_b = props === null || props === void 0 ? void 0 : props.query) === null || _b === void 0 ? void 0 : _b.sources) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.startsWith('query'))
                setOrigins(['query']);
            else
                setOrigins([]);
        }
    }, [props === null || props === void 0 ? void 0 : props.query]);
    useEffect(() => {
        if (view === 'init') {
            setLoadingSamples(true);
            getSampleQuestions(context).then(x => setSamples(x)).catch(console.error).finally(() => {
                setLoadingSamples(false);
            });
        }
    }, [view, context]);
    function getSource() {
        var _a, _b, _c;
        if ((_a = props === null || props === void 0 ? void 0 : props.query) === null || _a === void 0 ? void 0 : _a.sourceOnly)
            return ((_c = (_b = props === null || props === void 0 ? void 0 : props.query) === null || _b === void 0 ? void 0 : _b.sources) === null || _c === void 0 ? void 0 : _c[0]) || null;
        return null;
    }
    function submitQuestion(q) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!q.trim())
                return;
            try {
                setProcessingQuestion(true);
                let p = yield askQuestion(context, q);
                if (!p) {
                    setProcessingQuestion(false);
                    throw $L('lqe.is.error-generic');
                }
                if (p.question) {
                    alert(p.question);
                    setProcessingQuestion(false);
                    return;
                }
                if (p.steps && p.sources) {
                    props.onSetQuery(yield prepareQuery(context, p, origins));
                }
            }
            catch (e) {
                setProcessingQuestion(false);
                alert(e);
            }
        });
    }
    function addInitialSource(source) {
        return __awaiter(this, void 0, void 0, function* () {
            const schema = yield getSchemaForSource(context, {
                sources: [source],
                steps: []
            }, source.id);
            source.schema = schema;
            const sourceOnly = (origins === null || origins === void 0 ? void 0 : origins.length) > 0;
            props.onSetQuery({
                sources: [source],
                steps: [],
                sourceOnly
            });
            setView('init');
            setOrigins([]);
        });
    }
    const handleKeyDown = (e) => {
        var _a, _b;
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (question.trim()) {
                submitQuestion(question);
                (_b = (_a = context.uxpContext).trackAnalytics) === null || _b === void 0 ? void 0 : _b.call(_a, 'ask-question', {
                    message: question
                });
            }
        }
    };
    const handleSampleClick = (sampleQuestion) => {
        var _a, _b;
        setQuestion(sampleQuestion);
        submitQuestion(sampleQuestion);
        (_b = (_a = context.uxpContext).trackAnalytics) === null || _b === void 0 ? void 0 : _b.call(_a, 'pre-loaded-question', {
            message: sampleQuestion
        });
    };
    return React.createElement(React.Fragment, null,
        React.createElement(DataSourceBrowserModal, { show: view === 'source', onClose: () => {
                setView('init');
                setOrigins([]);
            }, source: getSource(), onSelect: addInitialSource, showCloseButton: true, origins: origins, query: generateInitialQuery() }),
        React.createElement("div", { className: "lqe-is-3e2fc74e" },
            processingQuestion && React.createElement(LoadingOverlay, { message: $L('lqe.is.processing') }),
            React.createElement("div", { className: "lqe-is__hd-3e2fc74e" },
                React.createElement("div", { className: "lqe-is__hd-title-3e2fc74e" }, $L('lqe.is.title')),
                React.createElement("div", { className: "lqe-is__hd-sub-3e2fc74e" }, $L('lqe.is.subtitle-1')),
                React.createElement("div", { className: "lqe-is__hd-sub-3e2fc74e" }, $L('lqe.is.subtitle-2'))),
            React.createElement("div", { className: "lqe-is__body-3e2fc74e" },
                React.createElement("div", { className: "lqe-is__content-3e2fc74e" },
                    React.createElement("div", { className: "lqe-is__ask-hd-3e2fc74e" }, $L('lqe.is.ask-heading')),
                    React.createElement("div", { className: "lqe-is__input-3e2fc74e" },
                        React.createElement(TextArea, { readOnly: processingQuestion, value: question, onChange: setQuestion, onKeyDown: handleKeyDown, rows: 3 })),
                    React.createElement("div", { className: "lqe-is__divider-3e2fc74e" },
                        React.createElement("span", { className: "lqe-is__divider-lbl-3e2fc74e" }, $L('lqe.is.divider-label'))),
                    React.createElement("div", { className: "lqe-is__samples-3e2fc74e" }, loadingSamples ? React.createElement("div", { className: "lqe-is__loading-3e2fc74e" },
                        React.createElement(Loading, { message: $L('lqe.is.loading-samples') })) : samples.map((sampleQuestion, i) => React.createElement("div", { key: i, className: "lqe-is__sample-3e2fc74e", onClick: () => handleSampleClick(sampleQuestion) }, sampleQuestion))))),
            React.createElement("div", { className: "lqe-is__ft-3e2fc74e" },
                React.createElement("div", { className: "lqe-is__cta-3e2fc74e" },
                    React.createElement("div", { className: "lqe-is__cta-lbl-3e2fc74e" }, $L('lqe.is.cta-src-label')),
                    React.createElement(ButtonComponent, { title: $L('lqe.is.cta-src-btn'), onClick: () => setView('source'), leftIcon: "fas plus", variant: "primary" })),
                (context === null || context === void 0 ? void 0 : context.canSelectSavedQuerries) && React.createElement("div", { className: "lqe-is__cta-3e2fc74e" },
                    React.createElement("div", { className: "lqe-is__cta-lbl-3e2fc74e" }, $L('lqe.is.cta-qry-label')),
                    React.createElement(ButtonComponent, { title: $L('lqe.is.cta-qry-btn'), onClick: () => {
                            setView('source');
                            setOrigins(['query']);
                        }, leftIcon: "fas bookmark", variant: "secondary" })))));
};
